// import { Component, OnInit } from '@angular/core';

import { Component, Input, OnInit, Inject, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ExtractFromLoadService } from '../extract-from-load.service';
import { MatOption } from "@angular/material/core";
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-params-popup',
  templateUrl: './params-popup.component.html',
  styleUrls: ['./params-popup.component.scss']
})
export class ParamsPopupComponent implements OnInit {

  public myControl = new FormControl();
  public options: any = [];
  public checked: false;
  fromTable: any;
  public filteredOptions: Observable<string[]>;
  public allComplete: false;
  public removedOptions: any = [];
  public addOptionsList: any = [];
  public selectedOptions: any = [];
  public cashmang: any;
  public checkedCategoryList: any;
  public gender: any;
  public auto: any;
  public headername: any;
  public selectedConfigData: any;
  searchValueA: string = '';
  searchValueB: string = '';
  sObject: any=[];
  rObject: any =[];
  toppings = new FormControl('');
  toppings1: any =[];
  compareType1 = "";
  compareType2 = "";
  scopeName:string;
  showScope: boolean = false;
  toppingList: any[];
  scopeIndex: any;
  dataObj: any;
  allSelect: boolean = false;
  @ViewChild('allSelected') private allSelected: MatOption;
  toppings2: any =[];
  paramData: any;
  dataSet: any;
  length: any;

  s_options: any = [];
  r_options: any = [];

  constructor(
    private http: HttpClient,private fb: FormBuilder,
    public dialogRef: MatDialogRef<ParamsPopupComponent>,
    private celService: ExtractFromLoadService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.headername = data.TASK_NAME? data.TASK_NAME : data.taskname;
    // this.selectedConfigData = Object.assign({}, data.configData);
  }

  ngOnInit(): void {
    this.fromTable = this.celService.fromTable;
    this.paramData = this.celService.paramData;   
    this.dataSet = JSON.parse(JSON.stringify(this.data));
    console.log('this.data----',this.data);
    if(this.fromTable){
      if(this.dataSet.paramVal != null){
        this.dataObj = this.dataSet.paramVal;
      } else{
        this.processBusinessObjectEdit(this.dataSet.BUSINESSOBJECT);
        this.dataObj = this.dataSet.BUSINESSOBJECT;
      }

    }else{
      if(this.dataSet.paramVal != null){
        this.dataObj = this.dataSet.paramVal;
      } else{
        this.processBusinessObject(this.dataSet.BUSINESSOBJECT);
        this.dataObj = this.dataSet.BUSINESSOBJECT;
      }   
    }
 
  }

 onCancel() {
  if(this.showScope){
    this.showScope = false;
  }else{
    this.dialogRef.close("");
  }
  }

  onOptionsclick(event, index, option) {
    if(event){
      const taskObj = option;
      taskObj.checkVal = true;
      const list = Array.prototype.concat.call(this.s_options, taskObj);
      list.sort((a, b) => a.indexVal - b.indexVal);
      this.s_options = list;
      this.r_options.splice(index, 1);

    }else{

      const taskObj = option;
      taskObj.checkVal = false;
      const list = Array.prototype.concat.call(this.r_options, taskObj);
      list.sort((a, b) => a.indexVal - b.indexVal);
      this.r_options = list;
      this.s_options.splice(index, 1);
    }
  }


  deSelectAll(event) {
    const taskList = this.s_options;
    taskList.forEach((element, index) => {
      element.checkVal = false;
    });
    const list = Array.prototype.concat.call(this.r_options, taskList);
    list.sort((a, b) => a.indexVal - b.indexVal);
    this.r_options = list;
    this.s_options=[];
    this.searchValueA ='';
    this.searchValueB ='';
    this.search(1,'');
    this.search(2,'');
  }

  selectAll(event) {
    const taskList = this.r_options;
    taskList.forEach((element, index) => {
      element.checkVal = true;
    });
    const list = Array.prototype.concat.call(this.s_options, taskList);
    list.sort((a, b) => a.indexVal - b.indexVal);
    this.s_options = list;
    this.r_options=[];
    this.searchValueA ='';
    this.searchValueB ='';
    this.search(1,'');
    this.search(2,'');
  }


  search(option,value) {
    const searchWord = value.trim().toUpperCase();
    if(option === 1){
      this.s_options = [...this.s_options,...this.sObject];
      this.s_options.sort((a, b) => a.indexVal - b.indexVal);
      this.sObject = [];
    }
    if(option === 2){
      this.r_options = [...this.r_options,...this.rObject];
      this.r_options.sort((a, b) => a.indexVal - b.indexVal);
      this.rObject = [];
    }

    if (this.fromTable) {
      if (option === 1) {
        const filterdValues = this.s_options.filter((val) => val.businessname?.toUpperCase().includes(searchWord));
        const otherValues = this.s_options.filter((val) => !val.businessname?.toUpperCase().includes(searchWord));
        this.s_options = filterdValues;
        this.sObject = otherValues;
      }
      if (option === 2) {
        const filterdValues = this.r_options.filter((val) => val.businessname?.toUpperCase().includes(searchWord));
        const otherValues = this.r_options.filter((val) => !val.businessname?.toUpperCase().includes(searchWord));
        this.r_options = filterdValues;
        this.rObject = otherValues;
      }
    } else {
      if (option === 1) {

        const filterdValues = this.s_options.filter((val) => val.businessname?.toUpperCase().includes(searchWord));
        const otherValues = this.s_options.filter((val) => !val.businessname?.toUpperCase().includes(searchWord));
        this.s_options = filterdValues;
        this.sObject = otherValues;
      }
      if (option === 2) {

        const filterdValues = this.r_options.filter((val) => val.businessname?.toUpperCase().includes(searchWord));
        const otherValues = this.r_options.filter((val) => !val.businessname?.toUpperCase().includes(searchWord));
        this.r_options = filterdValues;
        this.rObject = otherValues;
      }
    }
  }


  searchOnInput(event,i){
    if(event == null || event == undefined || event == ''){
      this.search(i,'');
    }else{
      this.search(i,event);
    }
  }



  processBusinessObject(BUSINESSOBJECT){
    const obj = [];
    BUSINESSOBJECT.forEach(e => {
      e.scope = false;
      e.params = [];
      obj.push(e);
    });
    this.dataSet.BUSINESSOBJECT = obj;
    this.allSelect = false;
  }

  processBusinessObjectEdit(BUSINESSOBJECT){
    const obj = [];
    BUSINESSOBJECT.forEach(e => {
      if(e.value != null){
        // const unitData = this.setParamsValue(e);
        e.scope = true;
        e.params = []; 
      }else{
        e.scope = false;
        e.params = [];
      }     
      obj.push(e);
    });
    this.dataSet.BUSINESSOBJECT = obj;
    this.allSelect = false;
  }

  // setParamsValue(e){

  // }


  saveOptions(){
    if(this.fromTable){
      this.dataObj.forEach(element => {
        const val = [];
        if(element.scope && element.params.length>0){
          element.params.forEach(e => {
              if(e.checkVal){
                // val.push(e.id != null ? e.id : e.businessname);
                val.push(e.id != null ? e.id : e.businessobjectcode1 != null ? e.businessobjectcode1 : e.businessname);
              }
            });
            element.value = val.join('|');  
          }
          });
      };
    const data = {
      savedData: true,
      dataObj: this.dataObj
    };
    this.dialogRef.close(data);
  }

  onScopeClick(val,i){
    this.showScope = true;
    this.scopeIndex= i;
    this.scopeName = val.name;
    const paramObj = [];
    this.s_options = [];
    this.r_options = [];
    if(val.scope){
      this.toppingList = JSON.parse(JSON.stringify(val.params));
      this.toppingList.forEach((ele,j) => {
        if(ele.checkVal){
          this.s_options.push(ele);
        }else{
          this.r_options.push(ele);
        }
      });
    }else{
      this.toppingList = this.paramData.filter(ele => val.name == ele.businessobject);
      this.toppingList.forEach((ele,j) => {
        ele.checkVal = false;
        ele.indexVal = j;
        paramObj.push(ele);
      });
      // this.toppingList = [...paramObj];
      this.r_options = [...paramObj];
    }
    this.length = this.toppingList.length;
    const count = this.toppingList.filter(value => value.checkVal == true).length;
    if( this.length === count){
      // document.getElementById("select").Checked = true;
      this.allSelect = true;
    }else{
      this.allSelect = false;
    }
    console.log("this.toppingList---",this.toppingList); 
  }

  
  onScopeClickEdit(val,i){
    this.showScope = true;
    this.scopeIndex= i;
    this.scopeName = val.name;
    this.s_options = [];
    this.r_options = [];
    const paramObj = [];
    if(val.scope){
      if(val.params?.length == 0){
        this.getParamsList(val);
      }else{
        this.toppingList = JSON.parse(JSON.stringify(val.params));
        this.toppingList.forEach((ele,j) => {
          if(ele.checkVal){
            this.s_options.push(ele);
          }else{
            this.r_options.push(ele);
          }
        });
      }      
    }else{
      this.toppingList = this.paramData.filter(ele => val.name == ele.businessobject);
      this.toppingList.forEach((ele,j) => {
        ele.checkVal = false;
        ele.indexVal = j;
        paramObj.push(ele);
        // this.r_options.push(ele);
      });
      this.r_options = [...paramObj];
      // this.toppingList = [...paramObj];
    }
    this.length = this.toppingList.length;
    const count = this.toppingList.filter(value => value.checkVal == true).length;
    if( this.length === count){
      // document.getElementById("select").Checked = true;
      this.allSelect = true;
    }else{
      this.allSelect = false;
    }
    console.log("this.toppingList---",this.toppingList); 
  }

  getParamsList(val){
    const values = val.value?.split('|') == undefined ? [] : val.value?.split('|');
    const list = JSON.parse(JSON.stringify(this.paramData.filter(ele => val.name == ele.businessobject)));
    const paramObj = [];
    this.s_options = [];
    this.r_options =[];
    list.forEach((ele,i) => {
      if( ele.id == null || ele.id == "" || ele.id == undefined ){
        if(ele.businessobjectcode1 == null || ele.businessobjectcode1 == "" || ele.businessobjectcode1 == undefined){
          ele.checkVal = values.includes(ele.businessname);
        }else{
          ele.checkVal = values.includes(ele.businessobjectcode1);
        }
      }else{
        ele.checkVal = values.includes(ele.id);
      }
      ele.indexVal = i;
      paramObj.push(ele);

      if(ele.checkVal){
        this.s_options.push(ele);
      }else{
        this.r_options.push(ele);
      }
    });
    this.toppingList = [...paramObj];

  }

  add(){
    this.searchValueA ='';
    this.searchValueB ='';
    this.search(1,'');
    this.search(2,'');
    const i = this.s_options.length;
    const list = [...this.s_options,...this.r_options];
    if( i > 0){
      this.dataObj[this.scopeIndex].scope = true;
      this.dataObj[this.scopeIndex].params = JSON.parse(JSON.stringify(list));
    }else{
      this.dataObj[this.scopeIndex].scope = false;
      this.dataObj[this.scopeIndex].params = JSON.parse(JSON.stringify(list));   
    } 
    console.log("this.dataObj[this.scopeIndex].params",this.dataObj);

    this.showScope = false;
  }
   
}
